export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// MQTT command strings sent to the device
export const MQTT_COMMANDS = {
  RESET_WATER: 'reset_water',
  START_FLUSHING: 'start_flushing',
  RESET_CARTRIDGE: 'resetCartridge',
  RESET: 'reset',
  RESET_SCREEN: 'resetScrapp',
  GET_SENSOR_SETTINGS: 'getSensorSettings',
  LOAD_DEFAULT_CALIBRATION: 'loadDefaultCalibration',
};

// MQTT Action Types
export const MQTT_ACTIONS = {
  WATER_REF_RESET: 'waterRefReset',
  WATER_FLUSH: 'waterFlush',
  CARTRIDGE_RESET: 'cartridgeReset',
  RESET: 'reset',
  SCREEN_RESET: 'screenReset',
  GET_SENSOR_SETTINGS: 'getSensorSettings',
  LOAD_DEFAULT_CALIBRATION: 'loadDefaultCalibration',
};

// Screen Modes
export const SCREEN_MODES = {
  WELCOME: 'welcome_screen',
  MANUAL_FLUSH: 'manual_flush_screen',
  OUT_OF_ORDER: 'outoforder_screen'
};

// Confirmation Types
export const CONFIRMATION_TYPES = {
  SCREEN_MODE_CHANGE: 'screenModeChange',
  WATER_REF_RESET: 'waterRefReset',
  WATER_FLUSH: 'waterFlush',
  SCREEN_RESET: 'screenReset',
  CARTRIDGE_RESET: 'cartridgeReset',
  RESET: 'reset',
  LOAD_DEFAULT_CALIBRATION: 'loadDefaultCalibration'
};

// Action Configurations
export const ACTION_CONFIGS = {
  [MQTT_ACTIONS.WATER_REF_RESET]: {
    deviceId: 'backend',
    direction: 'config',
    message: MQTT_COMMANDS.RESET_WATER,
    logMessage: 'Water reference reset command sent'
  },
  [MQTT_ACTIONS.WATER_FLUSH]: {
    direction: 'config',
    message: MQTT_COMMANDS.START_FLUSHING,
    logMessage: 'Water flush command sent',
    useDisplayId: true
  },
  [MQTT_ACTIONS.CARTRIDGE_RESET]: {
    direction: 'config',
    message: MQTT_COMMANDS.RESET_CARTRIDGE,
    logMessage: 'Cartridge reset command sent',
    useDisplayId: true
  },
  [MQTT_ACTIONS.RESET]: {
    direction: 'config',
    message: MQTT_COMMANDS.RESET,
    logMessage: 'Reset command sent',
    useDisplayId: true
  },
  [MQTT_ACTIONS.SCREEN_RESET]: {
    direction: 'config',
    message: MQTT_COMMANDS.RESET_SCREEN,
    logMessage: 'Screen reset command sent',
    useDisplayId: true
  },
  [MQTT_ACTIONS.GET_SENSOR_SETTINGS]: {
    direction: 'config',
    message: MQTT_COMMANDS.GET_SENSOR_SETTINGS,
    logMessage: 'Get sensor settings command sent',
    useDisplayId: true,
    awaitResponse: true,
  },
  [MQTT_ACTIONS.LOAD_DEFAULT_CALIBRATION]: {
    direction: 'config',
    message: MQTT_COMMANDS.LOAD_DEFAULT_CALIBRATION,
    logMessage: 'Load default calibration command sent',
    useDisplayId: true,
  },
};

// Screen Mode Messages
export const SCREEN_MODE_MESSAGES = {
  [SCREEN_MODES.OUT_OF_ORDER]: {
    screen: 'outoforder_screen',
    msg: 'Tracking...'
  },
  [SCREEN_MODES.WELCOME]: {
    screen: 'welcome_screen',
    msg: 'Tracking...'
  },
  [SCREEN_MODES.MANUAL_FLUSH]: {
    screen: 'manual_flush_screen',
    msg: 'Tracking...'
  }
};